var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TapsSummary.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0496989e!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TapsSummary.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/courses/pages/Reports/VerbalCharts/TapsSummary.vue
// module id = 2278
// module chunks = 61